module.exports = {
	"PRODUCTION": true
};


//////////////////
// WEBPACK FOOTER
// ./src/env.json
// module id = 142
// module chunks = 0